<app-dialog-wrapper>
  <div class="content">
    <ul class="content__cards">
      @for (address of addressList; track $index) {
        @let isDeliveryShipping = shippingMethod === ShippingMethod.Delivery;
        @let isDeliveryAvailable = isDeliveryAddressAvailable(address);

        <li
          class="content__cards_item card"
          [ngClass]="{
            selected: selectedAddressIndex() === $index,
            disabled: isDeliveryShipping && !isDeliveryAvailable
          }"
        >
          <div class="card__radio__container">
            <i class="icon icon-pin-outline"></i>
            <app-radio
              class="card__radio"
              name="address"
              [radioValue]="$index"
              label="{{ address | address }}"
              [(ngModel)]="selectedAddressIndex"
            />
          </div>
          @if (isDeliveryShipping && !isDeliveryAvailable) {
            <p class="card__warning">Delivery not available to this address</p>
          }
        </li>
      } @empty {
        <p>You haven't added any addresses yet</p>
      }
    </ul>

    @if (editable) {
      <div class="content__add-address">
        <button
          class="content__add-address_button"
          (click)="onAddAddressClick()"
        >
          + Add New Address
        </button>
      </div>
    }
  </div>

  <div footer class="footer">
    <app-button
      [outline]="true"
      [size]="ButtonSize.Large"
      [style]="ButtonStyle.Danger"
      (buttonClick)="closeDialog()"
    >
      Cancel
    </app-button>

    <app-button
      [disabled]="selectedAddressIndex() === -1"
      [size]="ButtonSize.Large"
      (buttonClick)="onSubmit()"
    >
      Confirm Address
    </app-button>
  </div>
</app-dialog-wrapper>
